import { Box } from '@mui/material'

interface PageHeaderProps {
  children: React.ReactNode
}

export const PageHeader = (props: PageHeaderProps) => {
  const { children } = props

  return (
    <Box
      sx={{
        background: '',
        padding: { xs: '16px 16px 0 16px' }
      }}
    >
      {children}
    </Box>
  )
}
